import Vue from "vue";
import VueRouter from "vue-router";

import Login from "../views/Login.vue";
import Index_Dash from "../views/Index_Dash.vue";
import Register from "../views/Register.vue";

import Inicio from "../components/Inicio/Inicio.vue";
import Calendario from "../components/Calendar/Calendario.vue";
import Clientes from "../components/Clients/Clientes.vue";
import Contratos from "../components/Contratos/Contratos.vue";
import Dashboard from "../components/Dashboard.vue";
import NotFound from "../views/error/NotFound.vue";

import Pruebas from "../components/pruebas/Prueba.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/p",
    name: "p",
    component: Pruebas,
  },
  {
    path: "/Inicio",
    name: " Inicio",
    component: Inicio,
  },
  {
    path: "/Calendario",
    name: " Calendario",
    component: Calendario,
  },
  {
    path: "/Clientes",
    name: " Clientes",
    component: Clientes,
  },
  {
    path: "/Contratos",
    name: "Contratos",
    component: Contratos,
  },

  {
    path: "/Dashboard",
    name: "Index_Dash",
    component: Index_Dash,
  },

  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/Register",
    name: "Regiser",
    component: Register,
  },
  // Ruta catch-all para manejar rutas no encontradas
  {
    path: "*",
    component: NotFound,
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
